// src/modules/app-views/crm/pages/Kanban/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { MoreOutlined, SettingOutlined } from '@ant-design/icons';
import { dropdownParameters, dropdownDivider } from 'layouts/Pages/PageHeader/dropdownMenus';
import { boardSettingsRef } from '../boardSettingsRef';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const crmKanbanMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',
    dropdownItems: [
      {
        key: 'boardSettings',
        label: 'board_settings',
        icon: <SettingOutlined />,
        onClick: () => {
          boardSettingsRef.current?.();
        },
      },
      dropdownDivider,
      dropdownParameters,
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default crmKanbanMenuButton;
